import styled from 'styled-components';
import colors from '../../../theme/Colors';
import theme from 'styled-theming';
import { NavLink } from 'react-router-dom';

const buttonBorderColor = theme.variants('brand', 'kind', {
    primary: { brenntag: colors.brenntag.primary, bcd: colors.bcd.primary },
    secondary: { brenntag: colors.brenntag.primary, bcd: colors.bcd.secondary },
    tertiary: {brenntag: colors.brenntag.secondary, bcd: colors.bcd.primary }
});

const buttonBackgroundColor = theme.variants('brand', 'kind', {
    primary: { brenntag: colors.brenntag.primary, bcd: colors.bcd.primary },
    secondary: { brenntag: 'white', bcd: 'white' }
});

const buttonTextColor = theme.variants('brand', 'kind', {
    primary: { brenntag: 'white', bcd: 'white'},
    secondary: { brenntag: colors.brenntag.primary, bcd: colors.bcd.secondary },
    tertiary: { brenntag: colors.brenntag.secondary, bcd: colors.bcd.primary }
});

interface ButtonProps {
    kind?: string;
    fullWidth?: boolean;
    small?: boolean;
    loading?: boolean;
}

export const SButton = styled.button<ButtonProps>`
    text-transform: uppercase;
    font-size: 13px;
    font-weight: normal;
    line-height: 15px;
    padding: 8px 12px;
    color: ${buttonTextColor};
    background-color: ${buttonBackgroundColor};
    border-style: solid;
    border-width: 2px;
    border-color: ${buttonBorderColor};
    width: ${props => props.fullWidth ? '100%' : 'auto'};
    
    &:hover {
        ${props => !props.disabled && `
            cursor: pointer;
        `};
    }
    &:disabled {
        opacity: 0.6;
    }    
`;

export const SNavButton = styled(NavLink) <ButtonProps>`
    text-transform: uppercase;
    text-decoration: none;
    font-size: 13px;
    font-weight: bold;
    line-height: 15px;
    padding: 8px 12px;
    color: ${buttonTextColor};
    background-color: #fff;
    border: 2px solid ${buttonBorderColor};
    width: ${props => props.fullWidth ? '100%' : 'auto'};
    display: block;
    box-sizing: inherit;
    text-align: center;
    ${props => props.small &&
        `transform: scale(0.8)`
    };
    &:hover {
        cursor: pointer;
    }
`;

SButton.defaultProps = {
    kind: 'primary',
    small: false
}